import styled from 'styled-components';

export type StyledContainerProps = {
  flexGrow?: string;
  flexWrap?: string;
  gap?: string;
  marginBottom?: string;
  marginTop?: string;
  justifyContent?: string;
  height?: string;
  padding?: string;
  width?: string;
};

export const StyledRow = styled.div<StyledContainerProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: ${(props) => props.flexWrap || 'noWrap'};
  gap: ${(props) => props.gap || '1rem'};
  margin-bottom: ${(props) => props.marginBottom || '0'};
  margin-top: ${(props) => props.marginTop || '0'};
  justify-content: ${(props) => props.justifyContent || 'center'};
  flex-grow: ${(props) => props.flexGrow || '1'};
  height: ${(props) => props.height || 'auto'};
  padding: ${(props) => props.padding || '0px'};
`;
